export default __webpack_public_path__ + "static/summer_particles-258f7d12e6a4f19e209bfcc7a5b00f54.png";